// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AcceptInviteData,
  AcceptInviteErrors,
  AcceptInviteResponses,
  AcceptPortalNdaData,
  AcceptPortalNdaErrors,
  AcceptPortalNdaResponses,
  AddEngagementPersonData,
  AddEngagementPersonErrors,
  AddEngagementPersonResponses,
  AddPortalPersonData,
  AddPortalPersonErrors,
  AddPortalPersonResponses,
  AdminActivityActionsData,
  AdminActivityActionsErrors,
  AdminActivityActionsResponses,
  AdminActivityAnalyticsData,
  AdminActivityAnalyticsErrors,
  AdminActivityAnalyticsResponses,
  AdminAddWorkspaceMemberData,
  AdminAddWorkspaceMemberErrors,
  AdminAddWorkspaceMemberResponses,
  AdminAssignStaffData,
  AdminAssignStaffErrors,
  AdminAssignStaffResponses,
  AdminCreateWorkspaceData,
  AdminCreateWorkspaceErrors,
  AdminCreateWorkspaceResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserResponses,
  AdminGetCurrentNdaData,
  AdminGetCurrentNdaErrors,
  AdminGetCurrentNdaResponses,
  AdminGetUserData,
  AdminGetUserErrors,
  AdminGetUserResponses,
  AdminGetWorkspaceData,
  AdminGetWorkspaceDataPolicyData,
  AdminGetWorkspaceDataPolicyErrors,
  AdminGetWorkspaceDataPolicyResponses,
  AdminGetWorkspaceErrors,
  AdminGetWorkspaceResponses,
  AdminListActivityData,
  AdminListActivityErrors,
  AdminListActivityResponses,
  AdminListUsersData,
  AdminListUsersErrors,
  AdminListUsersResponses,
  AdminListWorkspacesData,
  AdminListWorkspacesErrors,
  AdminListWorkspacesResponses,
  AdminLoadSampleData,
  AdminLoadSampleErrors,
  AdminLoadSampleResponses,
  AdminPublishNdaData,
  AdminPublishNdaErrors,
  AdminPublishNdaResponses,
  AdminSetUserStatusData,
  AdminSetUserStatusErrors,
  AdminSetUserStatusResponses,
  AdminSetWorkspaceDataPolicyData,
  AdminSetWorkspaceDataPolicyErrors,
  AdminSetWorkspaceDataPolicyResponses,
  AdminUnassignStaffData,
  AdminUnassignStaffErrors,
  AdminUnassignStaffResponses,
  AdminUpdateEngagementSettingsData,
  AdminUpdateEngagementSettingsErrors,
  AdminUpdateEngagementSettingsResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  ChangePasswordData,
  ChangePasswordErrors,
  ChangePasswordResponses,
  ConfirmContributorMapData,
  ConfirmContributorMapErrors,
  ConfirmContributorMapResponses,
  CreateClientInviteData,
  CreateClientInviteErrors,
  CreateClientInviteResponses,
  DownloadEngagementFileData,
  DownloadEngagementFileErrors,
  DownloadEngagementFileResponses,
  DownloadPortalFileData,
  DownloadPortalFileErrors,
  DownloadPortalFileResponses,
  EndPortalPreviewData,
  EndPortalPreviewResponses,
  ExportRecordData,
  ExportRecordErrors,
  ExportRecordResponses,
  FreezeIntakeData,
  FreezeIntakeErrors,
  FreezeIntakeResponses,
  GetActivityData,
  GetActivityErrors,
  GetActivityResponses,
  GetArtifactVersionData,
  GetArtifactVersionErrors,
  GetArtifactVersionResponses,
  GetAuthProvidersData,
  GetAuthProvidersErrors,
  GetAuthProvidersResponses,
  GetConfigVersionData,
  GetConfigVersionErrors,
  GetConfigVersionResponses,
  GetContributorMapData,
  GetContributorMapErrors,
  GetContributorMapResponses,
  GetDraftFlowData,
  GetDraftFlowErrors,
  GetDraftFlowResponses,
  GetDraftFlowRunData,
  GetDraftFlowRunErrors,
  GetDraftFlowRunResponses,
  GetEngagementCoverageData,
  GetEngagementCoverageErrors,
  GetEngagementCoverageResponses,
  GetEngagementData,
  GetEngagementDataRequestData,
  GetEngagementDataRequestErrors,
  GetEngagementDataRequestResponses,
  GetEngagementErrors,
  GetEngagementFileData,
  GetEngagementFileErrors,
  GetEngagementFileResponses,
  GetEngagementIntakeData,
  GetEngagementIntakeErrors,
  GetEngagementIntakeResponses,
  GetEngagementResponses,
  GetEngagementStateData,
  GetEngagementStateErrors,
  GetEngagementStateResponses,
  GetHealthData,
  GetHealthResponses,
  GetJobData,
  GetJobErrors,
  GetJobResponses,
  GetMeData,
  GetMeDetailData,
  GetMeDetailErrors,
  GetMeDetailResponses,
  GetMeErrors,
  GetMeResponses,
  GetMyWorkspaceData,
  GetMyWorkspaceErrors,
  GetMyWorkspaceResponses,
  GetPortalCoverageData,
  GetPortalCoverageErrors,
  GetPortalCoverageResponses,
  GetPortalDraftFlowRunData,
  GetPortalDraftFlowRunErrors,
  GetPortalDraftFlowRunResponses,
  GetPortalEngagementOverviewData,
  GetPortalEngagementOverviewErrors,
  GetPortalEngagementOverviewResponses,
  GetPortalEngagementStageData,
  GetPortalEngagementStageErrors,
  GetPortalEngagementStageResponses,
  GetPortalNdaData,
  GetPortalNdaErrors,
  GetPortalNdaResponses,
  GetPortalPreviewData,
  GetPortalPreviewErrors,
  GetPortalPreviewResponses,
  GetWorkspaceData,
  GetWorkspaceErrors,
  GetWorkspaceResponses,
  GoogleSsoStartData,
  GoogleSsoStartErrors,
  KeepPortalFileData,
  KeepPortalFileErrors,
  KeepPortalFileResponses,
  ListArtifactVersionsData,
  ListArtifactVersionsErrors,
  ListArtifactVersionsResponses,
  ListClientInvitesData,
  ListClientInvitesErrors,
  ListClientInvitesResponses,
  ListConfigVersionsData,
  ListConfigVersionsErrors,
  ListConfigVersionsResponses,
  ListEngagementFilesData,
  ListEngagementFilesErrors,
  ListEngagementFilesResponses,
  ListEngagementPeopleData,
  ListEngagementPeopleErrors,
  ListEngagementPeopleResponses,
  ListEngagementsData,
  ListEngagementsErrors,
  ListEngagementsResponses,
  ListNdaAcceptancesData,
  ListNdaAcceptancesErrors,
  ListNdaAcceptancesResponses,
  ListPortalFilesData,
  ListPortalFilesErrors,
  ListPortalFilesResponses,
  ListPortalPeopleData,
  ListPortalPeopleErrors,
  ListPortalPeopleResponses,
  ListRecordEntriesData,
  ListRecordEntriesErrors,
  ListRecordEntriesResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LogoutData,
  LogoutResponses,
  MarkPortalRowMissingData,
  MarkPortalRowMissingErrors,
  MarkPortalRowMissingResponses,
  ReleaseDraftFlowVersionData,
  ReleaseDraftFlowVersionErrors,
  ReleaseDraftFlowVersionResponses,
  RemoveEngagementPersonData,
  RemoveEngagementPersonErrors,
  RemoveEngagementPersonResponses,
  RemovePortalFileData,
  RemovePortalFileErrors,
  RemovePortalFileResponses,
  RemovePortalPersonData,
  RemovePortalPersonErrors,
  RemovePortalPersonResponses,
  ReplacePortalFileData,
  ReplacePortalFileErrors,
  ReplacePortalFileResponses,
  RequestPasswordResetData,
  RequestPasswordResetErrors,
  RequestPasswordResetResponses,
  ResendClientInviteData,
  ResendClientInviteErrors,
  ResendClientInviteResponses,
  ResetPasswordData,
  ResetPasswordErrors,
  ResetPasswordResponses,
  SaveContributorMapVersionData,
  SaveContributorMapVersionErrors,
  SaveContributorMapVersionResponses,
  SaveDataRequestVersionData,
  SaveDataRequestVersionErrors,
  SaveDataRequestVersionResponses,
  SaveDraftFlowVersionData,
  SaveDraftFlowVersionErrors,
  SaveDraftFlowVersionResponses,
  SaveIntakeDraftData,
  SaveIntakeDraftErrors,
  SaveIntakeDraftResponses,
  SetEngagementProcessCategoryData,
  SetEngagementProcessCategoryErrors,
  SetEngagementProcessCategoryResponses,
  SetShelfContextStatusData,
  SetShelfContextStatusErrors,
  SetShelfContextStatusResponses,
  StartDraftFlowRunData,
  StartDraftFlowRunErrors,
  StartDraftFlowRunResponses,
  StartPortalDraftFlowRunData,
  StartPortalDraftFlowRunErrors,
  StartPortalDraftFlowRunResponses,
  StartPortalPreviewData,
  StartPortalPreviewErrors,
  StartPortalPreviewResponses,
  UpdateCoverageRowData,
  UpdateCoverageRowErrors,
  UpdateCoverageRowResponses,
  UpdateEngagementPersonData,
  UpdateEngagementPersonErrors,
  UpdateEngagementPersonResponses,
  UpdatePortalPersonData,
  UpdatePortalPersonErrors,
  UpdatePortalPersonResponses,
  UpdateProfileData,
  UpdateProfileErrors,
  UpdateProfileResponses,
  UploadEngagementFileData,
  UploadEngagementFileErrors,
  UploadEngagementFileResponses,
  UploadPortalFileData,
  UploadPortalFileErrors,
  UploadPortalFileResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health
 *
 * Return the health status and the commit this deployment runs.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Auth Login
 *
 * Authenticate a CLIENT user via Supabase, then set the signed session cookie.
 *
 * Email + password is the client side only. BOI staff (a staff-domain email,
 * or a staff/admin profile) get 403 `sso_required`; for a staff-domain email
 * that is decided before the password ever reaches Supabase.
 *
 * The Supabase access/refresh tokens never leave the backend — the browser
 * only ever sees the HMAC cookie this endpoint sets.
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
): RequestResult<LoginResponses, LoginErrors, ThrowOnError> =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie and any portal preview.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Request Password Reset
 *
 * Email a client a password-reset link when the account exists.
 *
 * The answer is the same 202 for a known and an unknown email, so it never
 * tells whether an account exists. BOI staff get 403 `sso_required`.
 */
export const requestPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<RequestPasswordResetData, ThrowOnError>,
): RequestResult<RequestPasswordResetResponses, RequestPasswordResetErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RequestPasswordResetResponses,
    RequestPasswordResetErrors,
    ThrowOnError
  >({
    url: "/auth/password/forgot",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset Password
 *
 * Set a client's new password with the token from a password-reset email.
 *
 * Never signs the user in: no session cookie is set.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: "/auth/password/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Auth Providers
 *
 * List the external sign-in providers that are enabled in Supabase and this app can start.
 */
export const getAuthProviders = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthProvidersData, ThrowOnError>,
): RequestResult<GetAuthProvidersResponses, GetAuthProvidersErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetAuthProvidersResponses, GetAuthProvidersErrors, ThrowOnError>({
    url: "/auth/providers",
    ...options,
  });

/**
 * Google Sso Start
 *
 * Start BOI Google SSO: set the PKCE flow cookie and redirect to Supabase.
 *
 * The SPA navigates here with a full page load (it never calls this through
 * the SDK). Without FRONTEND_URL there is no callback to return to, so the
 * browser goes straight to `/login?sso_error=unavailable`, without a cookie.
 * Staff sessions always last 7 days, so there is no remember-me option.
 */
export const googleSsoStart = <ThrowOnError extends boolean = false>(
  options?: Options<GoogleSsoStartData, ThrowOnError>,
): RequestResult<unknown, GoogleSsoStartErrors, ThrowOnError> =>
  (options?.client ?? client).get<unknown, GoogleSsoStartErrors, ThrowOnError>({
    url: "/auth/oauth/google",
    ...options,
  });

/**
 * Auth Me
 *
 * Get the current user's profile.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });

/**
 * Auth Me Detail
 *
 * Get the current user's profile with timeline fields.
 */
export const getMeDetail = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeDetailData, ThrowOnError>,
): RequestResult<GetMeDetailResponses, GetMeDetailErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMeDetailResponses, GetMeDetailErrors, ThrowOnError>({
    url: "/auth/me/detail",
    ...options,
  });

/**
 * Auth Update Profile
 *
 * Update current user's name.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileData, ThrowOnError>,
): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: "/auth/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Change Password
 *
 * Change the current user's password (verifies current password first).
 *
 * Only for password sessions: BOI staff sign in with Google and have no
 * password here.
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>,
): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> =>
  (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: "/auth/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Activity
 *
 * Get the current user's activity log.
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options?: Options<GetActivityData, ThrowOnError>,
): RequestResult<GetActivityResponses, GetActivityErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetActivityResponses, GetActivityErrors, ThrowOnError>({
    url: "/auth/activity",
    ...options,
  });

/**
 * Admin List Users
 *
 * List all users (admin only).
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListUsersData, ThrowOnError>,
): RequestResult<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    url: "/admin/users",
    ...options,
  });

/**
 * Admin Delete User
 *
 * Delete a user (admin only). Self-deletion blocked.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Get User
 *
 * Get a single user detail with activity logs (admin only).
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetUserData, ThrowOnError>,
): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Update User
 *
 * Update a user's name or role (admin only). Self-demotion blocked.
 *
 * Roles must match the email domain: staff-domain users can only be staff or
 * admin, everyone else only client (400 `role_domain_mismatch` otherwise).
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set User Status
 *
 * Deactivate or reactivate a user (admin only), ending their live sessions.
 *
 * Either action on your own account is refused (400 `cannot_deactivate_self`).
 */
export const adminSetUserStatus = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetUserStatusData, ThrowOnError>,
): RequestResult<AdminSetUserStatusResponses, AdminSetUserStatusErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetUserStatusResponses,
    AdminSetUserStatusErrors,
    ThrowOnError
  >({
    url: "/admin/users/{user_id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Activity
 *
 * List activity across all users (admin only).
 *
 * Search, filtering, sorting, and pagination are all applied server-side by
 * the list_recent_activity RPC — the client sends params and renders results.
 */
export const adminListActivity = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListActivityData, ThrowOnError>,
): RequestResult<AdminListActivityResponses, AdminListActivityErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListActivityResponses,
    AdminListActivityErrors,
    ThrowOnError
  >({ url: "/admin/activity", ...options });

/**
 * Admin Activity Analytics
 *
 * Aggregated activity analytics for the admin dashboard (admin only).
 */
export const adminActivityAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityAnalyticsData, ThrowOnError>,
): RequestResult<AdminActivityAnalyticsResponses, AdminActivityAnalyticsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminActivityAnalyticsResponses,
    AdminActivityAnalyticsErrors,
    ThrowOnError
  >({ url: "/admin/activity/analytics", ...options });

/**
 * Admin Activity Actions
 *
 * Distinct activity actions across all time (admin only).
 *
 * Used to populate the activity filter dropdown so it matches the full,
 * unbounded table scope rather than the windowed analytics breakdown.
 */
export const adminActivityActions = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityActionsData, ThrowOnError>,
): RequestResult<AdminActivityActionsResponses, AdminActivityActionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminActivityActionsResponses,
    AdminActivityActionsErrors,
    ThrowOnError
  >({ url: "/admin/activity/actions", ...options });

/**
 * Admin List Workspaces
 *
 * List every workspace with its engagement, member and assigned-staff counts (admin only).
 */
export const adminListWorkspaces = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListWorkspacesData, ThrowOnError>,
): RequestResult<AdminListWorkspacesResponses, AdminListWorkspacesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListWorkspacesResponses,
    AdminListWorkspacesErrors,
    ThrowOnError
  >({ url: "/admin/workspaces", ...options });

/**
 * Admin Create Workspace
 *
 * Create a client workspace with its first engagement (admin only).
 */
export const adminCreateWorkspace = <ThrowOnError extends boolean = false>(
  options: Options<AdminCreateWorkspaceData, ThrowOnError>,
): RequestResult<AdminCreateWorkspaceResponses, AdminCreateWorkspaceErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminCreateWorkspaceResponses,
    AdminCreateWorkspaceErrors,
    ThrowOnError
  >({
    url: "/admin/workspaces",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Workspace
 *
 * Read a workspace with every engagement, its assigned staff and the client members.
 *
 * Embeds the first 100 members and the first 100 assignments per engagement, each with its
 * total. Admin only.
 */
export const adminGetWorkspace = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetWorkspaceData, ThrowOnError>,
): RequestResult<AdminGetWorkspaceResponses, AdminGetWorkspaceErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetWorkspaceResponses, AdminGetWorkspaceErrors, ThrowOnError>(
    { url: "/admin/workspaces/{workspace_id}", ...options },
  );

/**
 * Admin Get Workspace Data Policy
 *
 * Read a workspace's model policy and its latest changes (admin only).
 *
 * A workspace starts closed: no provider profile and no region, so no model runs on its data.
 */
export const adminGetWorkspaceDataPolicy = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetWorkspaceDataPolicyData, ThrowOnError>,
): RequestResult<
  AdminGetWorkspaceDataPolicyResponses,
  AdminGetWorkspaceDataPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminGetWorkspaceDataPolicyResponses,
    AdminGetWorkspaceDataPolicyErrors,
    ThrowOnError
  >({ url: "/admin/workspaces/{workspace_id}/data-policy", ...options });

/**
 * Admin Set Workspace Data Policy
 *
 * Replace a workspace's model policy with a reason (admin only); null names close it.
 *
 * A change lands in the engagement record as a workspace-level `policy_change` entry and,
 * once a provider is approved, queues the workspace's jobs that waited for one. The same
 * values again change nothing and answer the policy as it stands.
 */
export const adminSetWorkspaceDataPolicy = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetWorkspaceDataPolicyData, ThrowOnError>,
): RequestResult<
  AdminSetWorkspaceDataPolicyResponses,
  AdminSetWorkspaceDataPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminSetWorkspaceDataPolicyResponses,
    AdminSetWorkspaceDataPolicyErrors,
    ThrowOnError
  >({
    url: "/admin/workspaces/{workspace_id}/data-policy",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Add Workspace Member
 *
 * Add an existing client user to a workspace (admin only). Adding a member twice is a no-op.
 *
 * A client user belongs to one workspace at most (409 `client_in_other_workspace`).
 */
export const adminAddWorkspaceMember = <ThrowOnError extends boolean = false>(
  options: Options<AdminAddWorkspaceMemberData, ThrowOnError>,
): RequestResult<AdminAddWorkspaceMemberResponses, AdminAddWorkspaceMemberErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddWorkspaceMemberResponses,
    AdminAddWorkspaceMemberErrors,
    ThrowOnError
  >({
    url: "/admin/workspaces/{workspace_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Assign Staff
 *
 * Assign a staff member to an engagement (admin only). Assigning twice is a no-op.
 */
export const adminAssignStaff = <ThrowOnError extends boolean = false>(
  options: Options<AdminAssignStaffData, ThrowOnError>,
): RequestResult<AdminAssignStaffResponses, AdminAssignStaffErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminAssignStaffResponses, AdminAssignStaffErrors, ThrowOnError>({
    url: "/admin/engagements/{engagement_id}/assignments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Unassign Staff
 *
 * Remove a staff member from an engagement (admin only). Removing an absent one is a no-op.
 *
 * The staff member loses the engagement on their next request.
 */
export const adminUnassignStaff = <ThrowOnError extends boolean = false>(
  options: Options<AdminUnassignStaffData, ThrowOnError>,
): RequestResult<AdminUnassignStaffResponses, AdminUnassignStaffErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminUnassignStaffResponses,
    AdminUnassignStaffErrors,
    ThrowOnError
  >({ url: "/admin/engagements/{engagement_id}/assignments/{user_id}", ...options });

/**
 * List Engagements
 *
 * List the engagements the caller may reach: assigned ones for staff, all for admins.
 */
export const listEngagements = <ThrowOnError extends boolean = false>(
  options?: Options<ListEngagementsData, ThrowOnError>,
): RequestResult<ListEngagementsResponses, ListEngagementsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListEngagementsResponses, ListEngagementsErrors, ThrowOnError>({
    url: "/engagements",
    ...options,
  });

/**
 * Get Engagement
 *
 * Read one engagement: staff assigned to it, or an admin.
 */
export const getEngagement = <ThrowOnError extends boolean = false>(
  options: Options<GetEngagementData, ThrowOnError>,
): RequestResult<GetEngagementResponses, GetEngagementErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEngagementResponses, GetEngagementErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}",
    ...options,
  });

/**
 * Get Workspace
 *
 * Read a workspace: staff assigned to one of its engagements, or an admin.
 */
export const getWorkspace = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkspaceData, ThrowOnError>,
): RequestResult<GetWorkspaceResponses, GetWorkspaceErrors, ThrowOnError> =>
  (options.client ?? client).get<GetWorkspaceResponses, GetWorkspaceErrors, ThrowOnError>({
    url: "/workspaces/{workspace_id}",
    ...options,
  });

/**
 * Get My Workspace
 *
 * Read the signed-in client's own workspace (404 while they belong to none) or a preview's.
 */
export const getMyWorkspace = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyWorkspaceData, ThrowOnError>,
): RequestResult<GetMyWorkspaceResponses, GetMyWorkspaceErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMyWorkspaceResponses, GetMyWorkspaceErrors, ThrowOnError>({
    url: "/portal/workspace",
    ...options,
  });

/**
 * List Client Invites
 *
 * List the engagement's pending invites, newest first, one bounded page at a time.
 */
export const listClientInvites = <ThrowOnError extends boolean = false>(
  options: Options<ListClientInvitesData, ThrowOnError>,
): RequestResult<ListClientInvitesResponses, ListClientInvitesErrors, ThrowOnError> =>
  (options.client ?? client).get<ListClientInvitesResponses, ListClientInvitesErrors, ThrowOnError>(
    { url: "/engagements/{engagement_id}/invites", ...options },
  );

/**
 * Create Client Invite
 *
 * Invite a client email to the engagement and email them the link to set a password.
 *
 * Staff assigned to the engagement, and admins. A staff-domain address is refused before
 * anything is written or sent.
 */
export const createClientInvite = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientInviteData, ThrowOnError>,
): RequestResult<CreateClientInviteResponses, CreateClientInviteErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateClientInviteResponses,
    CreateClientInviteErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/invites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resend Client Invite
 *
 * Email a pending invite again with a new link; the earlier link stops working.
 *
 * 404 for an invite that is not pending on this engagement.
 */
export const resendClientInvite = <ThrowOnError extends boolean = false>(
  options: Options<ResendClientInviteData, ThrowOnError>,
): RequestResult<ResendClientInviteResponses, ResendClientInviteErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ResendClientInviteResponses,
    ResendClientInviteErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/invites/{invite_id}/resend", ...options });

/**
 * Accept Invite
 *
 * Accept an invite: spend its link, join the workspace, set the password and sign in.
 *
 * Unauthenticated: the link is the credential. The membership is created before the password
 * is set, so a password the policy refuses still leaves an accepted invite, and the client
 * picks a password through the reset flow.
 */
export const acceptInvite = <ThrowOnError extends boolean = false>(
  options: Options<AcceptInviteData, ThrowOnError>,
): RequestResult<AcceptInviteResponses, AcceptInviteErrors, ThrowOnError> =>
  (options.client ?? client).post<AcceptInviteResponses, AcceptInviteErrors, ThrowOnError>({
    url: "/auth/invite/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Record Entries
 *
 * One page of the engagement's record, with its workspace-level entries, in record order.
 */
export const listRecordEntries = <ThrowOnError extends boolean = false>(
  options: Options<ListRecordEntriesData, ThrowOnError>,
): RequestResult<ListRecordEntriesResponses, ListRecordEntriesErrors, ThrowOnError> =>
  (options.client ?? client).get<ListRecordEntriesResponses, ListRecordEntriesErrors, ThrowOnError>(
    { url: "/engagements/{engagement_id}/record", ...options },
  );

/**
 * Export Record
 *
 * The engagement's whole record as one JSON file, with its workspace-level entries.
 */
export const exportRecord = <ThrowOnError extends boolean = false>(
  options: Options<ExportRecordData, ThrowOnError>,
): RequestResult<ExportRecordResponses, ExportRecordErrors, ThrowOnError> =>
  (options.client ?? client).get<ExportRecordResponses, ExportRecordErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}/record/export",
    ...options,
  });

/**
 * Get Job
 *
 * Where one of the engagement's jobs stands: its status, attempts and result entry.
 */
export const getJob = <ThrowOnError extends boolean = false>(
  options: Options<GetJobData, ThrowOnError>,
): RequestResult<GetJobResponses, GetJobErrors, ThrowOnError> =>
  (options.client ?? client).get<GetJobResponses, GetJobErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}/jobs/{job_id}",
    ...options,
  });

/**
 * List Config Versions
 *
 * One page of published configuration versions, without their bodies.
 */
export const listConfigVersions = <ThrowOnError extends boolean = false>(
  options?: Options<ListConfigVersionsData, ThrowOnError>,
): RequestResult<ListConfigVersionsResponses, ListConfigVersionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListConfigVersionsResponses,
    ListConfigVersionsErrors,
    ThrowOnError
  >({ url: "/config", ...options });

/**
 * Get Config Version
 *
 * One published configuration version, with its body. A draft reads as missing.
 */
export const getConfigVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetConfigVersionData, ThrowOnError>,
): RequestResult<GetConfigVersionResponses, GetConfigVersionErrors, ThrowOnError> =>
  (options.client ?? client).get<GetConfigVersionResponses, GetConfigVersionErrors, ThrowOnError>({
    url: "/config/{category}/{kind}/{version}",
    ...options,
  });

/**
 * List Artifact Versions
 *
 * One page of the engagement's content versions, without their bodies.
 */
export const listArtifactVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListArtifactVersionsData, ThrowOnError>,
): RequestResult<ListArtifactVersionsResponses, ListArtifactVersionsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListArtifactVersionsResponses,
    ListArtifactVersionsErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/artifacts", ...options });

/**
 * Get Artifact Version
 *
 * One content version of the engagement, with its body.
 */
export const getArtifactVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetArtifactVersionData, ThrowOnError>,
): RequestResult<GetArtifactVersionResponses, GetArtifactVersionErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetArtifactVersionResponses,
    GetArtifactVersionErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/artifacts/{version_id}", ...options });

/**
 * Get Engagement State
 *
 * Where the engagement stands: its phase, settings, passed gates and configuration pins.
 */
export const getEngagementState = <ThrowOnError extends boolean = false>(
  options: Options<GetEngagementStateData, ThrowOnError>,
): RequestResult<GetEngagementStateResponses, GetEngagementStateErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetEngagementStateResponses,
    GetEngagementStateErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/state", ...options });

/**
 * Get Portal Engagement Stage
 *
 * Where the client's open engagement stands: its phase and the gates it passed.
 */
export const getPortalEngagementStage = <ThrowOnError extends boolean = false>(
  options?: Options<GetPortalEngagementStageData, ThrowOnError>,
): RequestResult<GetPortalEngagementStageResponses, GetPortalEngagementStageErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPortalEngagementStageResponses,
    GetPortalEngagementStageErrors,
    ThrowOnError
  >({ url: "/portal/engagement/stage", ...options });

/**
 * Admin Update Engagement Settings
 *
 * Change an engagement's settings with a reason (admin only); omitted fields stay.
 */
export const adminUpdateEngagementSettings = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateEngagementSettingsData, ThrowOnError>,
): RequestResult<
  AdminUpdateEngagementSettingsResponses,
  AdminUpdateEngagementSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AdminUpdateEngagementSettingsResponses,
    AdminUpdateEngagementSettingsErrors,
    ThrowOnError
  >({
    url: "/admin/engagements/{engagement_id}/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Load Sample
 *
 * Load a committed sample's registered kinds as released versions (admin, sample only).
 */
export const adminLoadSample = <ThrowOnError extends boolean = false>(
  options: Options<AdminLoadSampleData, ThrowOnError>,
): RequestResult<AdminLoadSampleResponses, AdminLoadSampleErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminLoadSampleResponses, AdminLoadSampleErrors, ThrowOnError>({
    url: "/admin/engagements/{engagement_id}/load-sample",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Engagement Intake
 *
 * Where the intake stands: the latest version, the freeze, the category and its pins.
 */
export const getEngagementIntake = <ThrowOnError extends boolean = false>(
  options: Options<GetEngagementIntakeData, ThrowOnError>,
): RequestResult<GetEngagementIntakeResponses, GetEngagementIntakeErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetEngagementIntakeResponses,
    GetEngagementIntakeErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/intake", ...options });

/**
 * Save Intake Draft
 *
 * Save the intake form as the next draft version; a reason is optional before the freeze.
 */
export const saveIntakeDraft = <ThrowOnError extends boolean = false>(
  options: Options<SaveIntakeDraftData, ThrowOnError>,
): RequestResult<SaveIntakeDraftResponses, SaveIntakeDraftErrors, ThrowOnError> =>
  (options.client ?? client).put<SaveIntakeDraftResponses, SaveIntakeDraftErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}/intake",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Engagement Process Category
 *
 * Choose the engagement's process category, or change it until the intake is frozen.
 *
 * The latest intake draft is kept as it is, its roles included.
 */
export const setEngagementProcessCategory = <ThrowOnError extends boolean = false>(
  options: Options<SetEngagementProcessCategoryData, ThrowOnError>,
): RequestResult<
  SetEngagementProcessCategoryResponses,
  SetEngagementProcessCategoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetEngagementProcessCategoryResponses,
    SetEngagementProcessCategoryErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/process-category",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freeze Intake
 *
 * Freeze the intake: pin configuration, generate the request and campaign, pass the gate.
 */
export const freezeIntake = <ThrowOnError extends boolean = false>(
  options: Options<FreezeIntakeData, ThrowOnError>,
): RequestResult<FreezeIntakeResponses, FreezeIntakeErrors, ThrowOnError> =>
  (options.client ?? client).post<FreezeIntakeResponses, FreezeIntakeErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}/gates/intake-frozen",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Engagement Data Request
 *
 * The engagement's latest data request, staff joins and staff notes included.
 */
export const getEngagementDataRequest = <ThrowOnError extends boolean = false>(
  options: Options<GetEngagementDataRequestData, ThrowOnError>,
): RequestResult<GetEngagementDataRequestResponses, GetEngagementDataRequestErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetEngagementDataRequestResponses,
    GetEngagementDataRequestErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/data-request", ...options });

/**
 * Save Data Request Version
 *
 * Save the edited data request with a reason, as the next released version.
 */
export const saveDataRequestVersion = <ThrowOnError extends boolean = false>(
  options: Options<SaveDataRequestVersionData, ThrowOnError>,
): RequestResult<SaveDataRequestVersionResponses, SaveDataRequestVersionErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SaveDataRequestVersionResponses,
    SaveDataRequestVersionErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/data-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Portal Engagement Overview
 *
 * The client's engagement: its frozen intake and released data request, once frozen.
 */
export const getPortalEngagementOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetPortalEngagementOverviewData, ThrowOnError>,
): RequestResult<
  GetPortalEngagementOverviewResponses,
  GetPortalEngagementOverviewErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPortalEngagementOverviewResponses,
    GetPortalEngagementOverviewErrors,
    ThrowOnError
  >({ url: "/portal/engagement", ...options });

/**
 * Get Portal Nda
 *
 * The NDA in force, and whether the signed-in client accepted it for their workspace.
 */
export const getPortalNda = <ThrowOnError extends boolean = false>(
  options?: Options<GetPortalNdaData, ThrowOnError>,
): RequestResult<GetPortalNdaResponses, GetPortalNdaErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPortalNdaResponses, GetPortalNdaErrors, ThrowOnError>({
    url: "/portal/nda",
    ...options,
  });

/**
 * Accept Portal Nda
 *
 * Accept the NDA version the client read, named by its id and content hash.
 */
export const acceptPortalNda = <ThrowOnError extends boolean = false>(
  options: Options<AcceptPortalNdaData, ThrowOnError>,
): RequestResult<AcceptPortalNdaResponses, AcceptPortalNdaErrors, ThrowOnError> =>
  (options.client ?? client).post<AcceptPortalNdaResponses, AcceptPortalNdaErrors, ThrowOnError>({
    url: "/portal/nda/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Current Nda
 *
 * The NDA version in force, or null while none is published (admin only).
 */
export const adminGetCurrentNda = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetCurrentNdaData, ThrowOnError>,
): RequestResult<AdminGetCurrentNdaResponses, AdminGetCurrentNdaErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminGetCurrentNdaResponses,
    AdminGetCurrentNdaErrors,
    ThrowOnError
  >({ url: "/admin/nda", ...options });

/**
 * Admin Publish Nda
 *
 * Publish a new NDA version, in force at once; every client accepts it again (admin only).
 */
export const adminPublishNda = <ThrowOnError extends boolean = false>(
  options: Options<AdminPublishNdaData, ThrowOnError>,
): RequestResult<AdminPublishNdaResponses, AdminPublishNdaErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminPublishNdaResponses, AdminPublishNdaErrors, ThrowOnError>({
    url: "/admin/nda",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Nda Acceptances
 *
 * Who in the engagement's workspace accepted which NDA version and when, newest first.
 */
export const listNdaAcceptances = <ThrowOnError extends boolean = false>(
  options: Options<ListNdaAcceptancesData, ThrowOnError>,
): RequestResult<ListNdaAcceptancesResponses, ListNdaAcceptancesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListNdaAcceptancesResponses,
    ListNdaAcceptancesErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/nda-acceptances", ...options });

/**
 * Start Portal Preview
 *
 * Start a read-only preview of the engagement's client portal (assigned staff or admins).
 */
export const startPortalPreview = <ThrowOnError extends boolean = false>(
  options: Options<StartPortalPreviewData, ThrowOnError>,
): RequestResult<StartPortalPreviewResponses, StartPortalPreviewErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StartPortalPreviewResponses,
    StartPortalPreviewErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/portal-preview", ...options });

/**
 * End Portal Preview
 *
 * Exit the portal preview: clear its cookie. The staff session stays signed in.
 */
export const endPortalPreview = <ThrowOnError extends boolean = false>(
  options?: Options<EndPortalPreviewData, ThrowOnError>,
): RequestResult<EndPortalPreviewResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).delete<EndPortalPreviewResponses, unknown, ThrowOnError>({
    url: "/portal/preview",
    ...options,
  });

/**
 * Get Portal Preview
 *
 * The caller's live portal preview: which client, and when it ends (404 when none).
 */
export const getPortalPreview = <ThrowOnError extends boolean = false>(
  options?: Options<GetPortalPreviewData, ThrowOnError>,
): RequestResult<GetPortalPreviewResponses, GetPortalPreviewErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPortalPreviewResponses, GetPortalPreviewErrors, ThrowOnError>({
    url: "/portal/preview",
    ...options,
  });

/**
 * List Portal People
 *
 * The people named for the client's open engagement, oldest first, one page at a time.
 */
export const listPortalPeople = <ThrowOnError extends boolean = false>(
  options?: Options<ListPortalPeopleData, ThrowOnError>,
): RequestResult<ListPortalPeopleResponses, ListPortalPeopleErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListPortalPeopleResponses, ListPortalPeopleErrors, ThrowOnError>({
    url: "/portal/engagement/people",
    ...options,
  });

/**
 * Add Portal Person
 *
 * Name a person for the open engagement; a client approver is invited at once.
 */
export const addPortalPerson = <ThrowOnError extends boolean = false>(
  options: Options<AddPortalPersonData, ThrowOnError>,
): RequestResult<AddPortalPersonResponses, AddPortalPersonErrors, ThrowOnError> =>
  (options.client ?? client).post<AddPortalPersonResponses, AddPortalPersonErrors, ThrowOnError>({
    url: "/portal/engagement/people",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Portal Person
 *
 * Remove a person; a pending invite of an email nobody else on the list holds is withdrawn.
 */
export const removePortalPerson = <ThrowOnError extends boolean = false>(
  options: Options<RemovePortalPersonData, ThrowOnError>,
): RequestResult<RemovePortalPersonResponses, RemovePortalPersonErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemovePortalPersonResponses,
    RemovePortalPersonErrors,
    ThrowOnError
  >({ url: "/portal/engagement/people/{person_id}", ...options });

/**
 * Update Portal Person
 *
 * Replace a person's fields; their aliases stay as staff set them.
 */
export const updatePortalPerson = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePortalPersonData, ThrowOnError>,
): RequestResult<UpdatePortalPersonResponses, UpdatePortalPersonErrors, ThrowOnError> =>
  (options.client ?? client).put<
    UpdatePortalPersonResponses,
    UpdatePortalPersonErrors,
    ThrowOnError
  >({
    url: "/portal/engagement/people/{person_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Engagement People
 *
 * The engagement's people, with their aliases, oldest first, one page at a time.
 */
export const listEngagementPeople = <ThrowOnError extends boolean = false>(
  options: Options<ListEngagementPeopleData, ThrowOnError>,
): RequestResult<ListEngagementPeopleResponses, ListEngagementPeopleErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListEngagementPeopleResponses,
    ListEngagementPeopleErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/people", ...options });

/**
 * Add Engagement Person
 *
 * Name a person for the engagement, with a reason; a client approver is invited at once.
 */
export const addEngagementPerson = <ThrowOnError extends boolean = false>(
  options: Options<AddEngagementPersonData, ThrowOnError>,
): RequestResult<AddEngagementPersonResponses, AddEngagementPersonErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddEngagementPersonResponses,
    AddEngagementPersonErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/people",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Engagement Person
 *
 * Remove a person, with a reason.
 */
export const removeEngagementPerson = <ThrowOnError extends boolean = false>(
  options: Options<RemoveEngagementPersonData, ThrowOnError>,
): RequestResult<RemoveEngagementPersonResponses, RemoveEngagementPersonErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemoveEngagementPersonResponses,
    RemoveEngagementPersonErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/people/{person_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Engagement Person
 *
 * Replace a person's fields, with a reason; omitted aliases stay as they are.
 */
export const updateEngagementPerson = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEngagementPersonData, ThrowOnError>,
): RequestResult<UpdateEngagementPersonResponses, UpdateEngagementPersonErrors, ThrowOnError> =>
  (options.client ?? client).put<
    UpdateEngagementPersonResponses,
    UpdateEngagementPersonErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/people/{person_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Portal Files
 *
 * The files the client shared into the open engagement, newest first, one page at a time.
 */
export const listPortalFiles = <ThrowOnError extends boolean = false>(
  options?: Options<ListPortalFilesData, ThrowOnError>,
): RequestResult<ListPortalFilesResponses, ListPortalFilesErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListPortalFilesResponses, ListPortalFilesErrors, ThrowOnError>({
    url: "/portal/files",
    ...options,
  });

/**
 * Upload Portal File
 *
 * Share a file into one row of the released data request; it is scanned before it is stored.
 */
export const uploadPortalFile = <ThrowOnError extends boolean = false>(
  options: Options<UploadPortalFileData, ThrowOnError>,
): RequestResult<UploadPortalFileResponses, UploadPortalFileErrors, ThrowOnError> =>
  (options.client ?? client).post<UploadPortalFileResponses, UploadPortalFileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: "/portal/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Download Portal File
 *
 * Download a file the client shared, as an attachment.
 */
export const downloadPortalFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadPortalFileData, ThrowOnError>,
): RequestResult<DownloadPortalFileResponses, DownloadPortalFileErrors, ThrowOnError> =>
  (options.client ?? client).get<
    DownloadPortalFileResponses,
    DownloadPortalFileErrors,
    ThrowOnError
  >({ url: "/portal/files/{file_id}/download", ...options });

/**
 * Remove Portal File
 *
 * Remove a file the client shared by mistake: its row, its text and its stored copy.
 */
export const removePortalFile = <ThrowOnError extends boolean = false>(
  options: Options<RemovePortalFileData, ThrowOnError>,
): RequestResult<RemovePortalFileResponses, RemovePortalFileErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemovePortalFileResponses,
    RemovePortalFileErrors,
    ThrowOnError
  >({ url: "/portal/files/{file_id}", ...options });

/**
 * Keep Portal File
 *
 * Keep a flagged file as it is: the client releases it, and it is read like any upload.
 */
export const keepPortalFile = <ThrowOnError extends boolean = false>(
  options: Options<KeepPortalFileData, ThrowOnError>,
): RequestResult<KeepPortalFileResponses, KeepPortalFileErrors, ThrowOnError> =>
  (options.client ?? client).post<KeepPortalFileResponses, KeepPortalFileErrors, ThrowOnError>({
    url: "/portal/files/{file_id}/keep",
    ...options,
  });

/**
 * Replace Portal File
 *
 * Replace a flagged file with a cleaned version in its row; the flagged one is removed.
 */
export const replacePortalFile = <ThrowOnError extends boolean = false>(
  options: Options<ReplacePortalFileData, ThrowOnError>,
): RequestResult<ReplacePortalFileResponses, ReplacePortalFileErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ReplacePortalFileResponses,
    ReplacePortalFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/portal/files/{file_id}/replacement",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Portal Coverage
 *
 * How complete the client's open engagement is: the sources, the gap requests, the shelf.
 */
export const getPortalCoverage = <ThrowOnError extends boolean = false>(
  options?: Options<GetPortalCoverageData, ThrowOnError>,
): RequestResult<GetPortalCoverageResponses, GetPortalCoverageErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPortalCoverageResponses,
    GetPortalCoverageErrors,
    ThrowOnError
  >({ url: "/portal/coverage", ...options });

/**
 * Mark Portal Row Missing
 *
 * Say the client does not have one requested item, with a reason; BOI stops asking for it.
 */
export const markPortalRowMissing = <ThrowOnError extends boolean = false>(
  options: Options<MarkPortalRowMissingData, ThrowOnError>,
): RequestResult<MarkPortalRowMissingResponses, MarkPortalRowMissingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MarkPortalRowMissingResponses,
    MarkPortalRowMissingErrors,
    ThrowOnError
  >({
    url: "/portal/coverage/rows/{request_item_key}/missing",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Portal Draft Flow Run
 *
 * Where the client's start of the draft flow stands, and what essential items are open.
 */
export const getPortalDraftFlowRun = <ThrowOnError extends boolean = false>(
  options?: Options<GetPortalDraftFlowRunData, ThrowOnError>,
): RequestResult<GetPortalDraftFlowRunResponses, GetPortalDraftFlowRunErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPortalDraftFlowRunResponses,
    GetPortalDraftFlowRunErrors,
    ThrowOnError
  >({ url: "/portal/draft-flow/run", ...options });

/**
 * Start Portal Draft Flow Run
 *
 * Start the draft flow: the documents are on BOI's side. A second press queues none.
 */
export const startPortalDraftFlowRun = <ThrowOnError extends boolean = false>(
  options?: Options<StartPortalDraftFlowRunData, ThrowOnError>,
): RequestResult<StartPortalDraftFlowRunResponses, StartPortalDraftFlowRunErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    StartPortalDraftFlowRunResponses,
    StartPortalDraftFlowRunErrors,
    ThrowOnError
  >({ url: "/portal/draft-flow/run", ...options });

/**
 * List Engagement Files
 *
 * One page of the engagement's files in one view, newest first.
 *
 * A `status` outside the view's statuses matches nothing; `page_size` is clamped to 1-100.
 */
export const listEngagementFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListEngagementFilesData, ThrowOnError>,
): RequestResult<ListEngagementFilesResponses, ListEngagementFilesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListEngagementFilesResponses,
    ListEngagementFilesErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/files", ...options });

/**
 * Upload Engagement File
 *
 * Add a file to the engagement with a reason; only evidence is scanned.
 */
export const uploadEngagementFile = <ThrowOnError extends boolean = false>(
  options: Options<UploadEngagementFileData, ThrowOnError>,
): RequestResult<UploadEngagementFileResponses, UploadEngagementFileErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UploadEngagementFileResponses,
    UploadEngagementFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/engagements/{engagement_id}/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Engagement File
 *
 * One file of the engagement.
 */
export const getEngagementFile = <ThrowOnError extends boolean = false>(
  options: Options<GetEngagementFileData, ThrowOnError>,
): RequestResult<GetEngagementFileResponses, GetEngagementFileErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEngagementFileResponses, GetEngagementFileErrors, ThrowOnError>(
    { url: "/engagements/{engagement_id}/files/{file_id}", ...options },
  );

/**
 * Download Engagement File
 *
 * Download a file of the engagement, as an attachment.
 */
export const downloadEngagementFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadEngagementFileData, ThrowOnError>,
): RequestResult<DownloadEngagementFileResponses, DownloadEngagementFileErrors, ThrowOnError> =>
  (options.client ?? client).get<
    DownloadEngagementFileResponses,
    DownloadEngagementFileErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/files/{file_id}/download", ...options });

/**
 * Get Engagement Coverage
 *
 * The engagement's coverage, its row table and the shelf-context status.
 */
export const getEngagementCoverage = <ThrowOnError extends boolean = false>(
  options: Options<GetEngagementCoverageData, ThrowOnError>,
): RequestResult<GetEngagementCoverageResponses, GetEngagementCoverageErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetEngagementCoverageResponses,
    GetEngagementCoverageErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/coverage", ...options });

/**
 * Update Coverage Row
 *
 * Set one row's gap note or status, with a reason, as a new data-request version.
 */
export const updateCoverageRow = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCoverageRowData, ThrowOnError>,
): RequestResult<UpdateCoverageRowResponses, UpdateCoverageRowErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateCoverageRowResponses, UpdateCoverageRowErrors, ThrowOnError>(
    {
      url: "/engagements/{engagement_id}/coverage/rows/{request_item_key}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * Set Shelf Context Status
 *
 * Mark the shelf context in or confirmed missing, with a reason; this opens interviews.
 */
export const setShelfContextStatus = <ThrowOnError extends boolean = false>(
  options: Options<SetShelfContextStatusData, ThrowOnError>,
): RequestResult<SetShelfContextStatusResponses, SetShelfContextStatusErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SetShelfContextStatusResponses,
    SetShelfContextStatusErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/shelf-context-status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Draft Flow
 *
 * The latest draft flow with its steps, the released version, and a page of versions.
 */
export const getDraftFlow = <ThrowOnError extends boolean = false>(
  options: Options<GetDraftFlowData, ThrowOnError>,
): RequestResult<GetDraftFlowResponses, GetDraftFlowErrors, ThrowOnError> =>
  (options.client ?? client).get<GetDraftFlowResponses, GetDraftFlowErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}/draft-flow",
    ...options,
  });

/**
 * Save Draft Flow Version
 *
 * Save the edited draft flow as the next draft version, with a reason.
 */
export const saveDraftFlowVersion = <ThrowOnError extends boolean = false>(
  options: Options<SaveDraftFlowVersionData, ThrowOnError>,
): RequestResult<SaveDraftFlowVersionResponses, SaveDraftFlowVersionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SaveDraftFlowVersionResponses,
    SaveDraftFlowVersionErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/draft-flow/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Release Draft Flow Version
 *
 * Release a draft-flow version; the released one before it becomes `superseded`.
 */
export const releaseDraftFlowVersion = <ThrowOnError extends boolean = false>(
  options: Options<ReleaseDraftFlowVersionData, ThrowOnError>,
): RequestResult<ReleaseDraftFlowVersionResponses, ReleaseDraftFlowVersionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ReleaseDraftFlowVersionResponses,
    ReleaseDraftFlowVersionErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/draft-flow/versions/{version_id}/release", ...options });

/**
 * Get Draft Flow Run
 *
 * Where the draft-flow run stands: its latest run and the open essential items.
 */
export const getDraftFlowRun = <ThrowOnError extends boolean = false>(
  options: Options<GetDraftFlowRunData, ThrowOnError>,
): RequestResult<GetDraftFlowRunResponses, GetDraftFlowRunErrors, ThrowOnError> =>
  (options.client ?? client).get<GetDraftFlowRunResponses, GetDraftFlowRunErrors, ThrowOnError>({
    url: "/engagements/{engagement_id}/draft-flow/run",
    ...options,
  });

/**
 * Start Draft Flow Run
 *
 * Start the draft flow for the client, with the staff member as the actor.
 *
 * A start while a run is queued or running returns that run; after a failed run it queues a
 * new one.
 */
export const startDraftFlowRun = <ThrowOnError extends boolean = false>(
  options: Options<StartDraftFlowRunData, ThrowOnError>,
): RequestResult<StartDraftFlowRunResponses, StartDraftFlowRunErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StartDraftFlowRunResponses,
    StartDraftFlowRunErrors,
    ThrowOnError
  >({ url: "/engagements/{engagement_id}/draft-flow/run", ...options });

/**
 * Get Contributor Map
 *
 * A session's latest contributor map with its steps, a page of versions, and the session.
 */
export const getContributorMap = <ThrowOnError extends boolean = false>(
  options: Options<GetContributorMapData, ThrowOnError>,
): RequestResult<GetContributorMapResponses, GetContributorMapErrors, ThrowOnError> =>
  (options.client ?? client).get<GetContributorMapResponses, GetContributorMapErrors, ThrowOnError>(
    { url: "/engagements/{engagement_id}/sessions/{session_id}/map", ...options },
  );

/**
 * Save Contributor Map Version
 *
 * Save the edited contributor map as the next draft version; the session never moves.
 */
export const saveContributorMapVersion = <ThrowOnError extends boolean = false>(
  options: Options<SaveContributorMapVersionData, ThrowOnError>,
): RequestResult<
  SaveContributorMapVersionResponses,
  SaveContributorMapVersionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SaveContributorMapVersionResponses,
    SaveContributorMapVersionErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/sessions/{session_id}/map/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm Contributor Map
 *
 * Record a hand-run contributor's confirmation: freeze the latest map, submit the session.
 */
export const confirmContributorMap = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmContributorMapData, ThrowOnError>,
): RequestResult<ConfirmContributorMapResponses, ConfirmContributorMapErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ConfirmContributorMapResponses,
    ConfirmContributorMapErrors,
    ThrowOnError
  >({
    url: "/engagements/{engagement_id}/sessions/{session_id}/map/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
